import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { RiskDetails, RiskType } from '@/models';
import { getLevelByRiskType } from '@/helpers';
import { RiskDetailsTagInfoItem, SvgIcon } from '@/components';
import { RiskKeys } from '@/config';
import styles from './RiskDetailsTagInfo.module.sass';

interface RiskDetailsTagInfoProps {
  category: string;
  risks: RiskDetails[];
  children?: ReactNode;
}

const RiskDetailsTagInfo = ({
  category,
  risks = [],
  children,
}: RiskDetailsTagInfoProps) => {
  const { t } = useTranslation();

  const categoryType =
    category === RiskKeys.SANCTIONS ? category : getLevelByRiskType(category);
  const categoryLabel = t(`translation.risk_explanation_level_${categoryType}`);

  const classes = cx(styles.category, styles[`category--${category}`]);

  return (
    <div className={classes}>
      <div className={styles.head}>
        <div className={styles.title}>
          <SvgIcon name={`risk-${category}`} className={styles.icon} />
          <span className={styles.name}>{categoryLabel}</span>
        </div>
        <span className={styles.spacer} />
      </div>
      <div className={styles.items}>
        {risks.map((risk) => (
          <RiskDetailsTagInfoItem
            key={risk.label}
            type={category as RiskType}
            label={risk.label}
          />
        ))}
      </div>
      {children}
    </div>
  );
};

export default RiskDetailsTagInfo;
